import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Hombres de 45 a 65 años que sienten rigidez matutina severa.', 'Trabajadores que pasan muchas horas de pie o sentados y terminan el día agotados.', 'Personas que quieren evitar cirugías de rodilla o cadera en el futuro.', 'Padres y abuelos que no quieren renunciar a su vida activa por el dolor.'];
  const isNotFor = ['Personas que buscan una "cura milagrosa" sin dedicarle 10 minutos a su salud.', 'Atletas profesionales que buscan rendimiento olímpico.', 'Personas con lesiones agudas que requieren intervención quirúrgica inmediata.'];
  return <section className="bg-stone-100 text-stone-800 py-24 px-4 border-t border-stone-200" data-id="element-141">
      <div className="max-w-6xl mx-auto" data-id="element-142">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-143">
          <FadeIn data-id="element-144">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border-t-8 border-amber-500 h-full" data-id="element-145">
              <h3 className="text-2xl md:text-3xl font-black mb-8 text-stone-900" data-id="element-146">
                Para quién ES
              </h3>
              <ul className="space-y-6" data-id="element-147">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-148">
                    <div className="bg-amber-100 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-149">
                      <Check className="w-5 h-5 text-amber-700" strokeWidth={3} data-id="element-150" />
                    </div>
                    <span className="text-lg text-stone-600" data-id="element-151">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-152">
            <div className="bg-stone-50 p-8 md:p-10 rounded-3xl shadow-sm border border-stone-200 h-full" data-id="element-153">
              <h3 className="text-2xl md:text-3xl font-black mb-8 text-stone-400" data-id="element-154">
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-155">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-75" data-id="element-156">
                    <div className="bg-stone-200 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-157">
                      <X className="w-5 h-5 text-stone-500" strokeWidth={3} data-id="element-158" />
                    </div>
                    <span className="text-lg text-stone-500" data-id="element-159">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}